var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tag',{staticClass:"prd-status-tag",attrs:{"rounded":"","type":_vm.config.type}},[_c('b-icon',{attrs:{"icon":_vm.config.icon,"size":"is-small"}}),_c('span',[_vm._v(_vm._s(_vm.config.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }